<div class="ai-message-list">
  <ng-container *ngFor="let item of listItems; trackBy: trackByItem">

    <!-- Agent switch separator -->
    <div *ngIf="item.kind === 'agent-switch'" class="ai-agent-switch">
      <span class="ai-agent-switch-line"></span>
      <div class="ai-agent-switch-badge" [style.--agent-color]="item.agentColor">
        <span class="ai-agent-switch-icon" [style.background]="item.agentColor + '22'">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
            [attr.stroke]="item.agentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <path [attr.d]="getAgentSvg(item.agentIcon || '')"/>
          </svg>
        </span>
        <span class="ai-agent-switch-label">Switched to <strong>{{ item.agentName }}</strong></span>
      </div>
      <span class="ai-agent-switch-line"></span>
    </div>

    <!-- Regular message -->
    <app-ai-message-shell
      *ngIf="item.kind === 'message'"
      [message]="item.message!"
      [agentName]="item.resolvedAgentName || 'Security Assistant'"
      (auditRequested)="auditRequested.emit($event)"
      (followUpSelected)="followUpSelected.emit($event)"
    ></app-ai-message-shell>

  </ng-container>
</div>
